// Etiquetas de permisos que ve el usuario (un owner asignando permisos a un
// colaborador). Fuente ÚNICA: antes estaban duplicadas dentro de addUserModal.js.
//
// El backend modela cada permiso como (tab, control). Acá traducimos a textos
// claros para alguien no técnico, alineados con el vocabulario de los botones
// reales de la app ("Editar", no "Actualizar"; "Ver", no "Leer").

export const TAB_LABELS = {
  movement_in: "Ingresos",
  movement_out: "Egresos",
  product: "Productos",
  user: "Usuarios",
  role: "Roles",
  rol_permission: "Configuración de Roles",
};

export const CONTROL_LABELS = {
  create: "Crear",
  read: "Ver",
  update: "Editar",
  delete: "Eliminar",
  assign: "Asignar",
};

// Tabs sin funcionalidad ni enforcement todavía (no existe pantalla de roles): no
// se muestran en la asignación de permisos para no ofrecer permisos sin efecto.
export const HIDDEN_TABS = ["role", "rol_permission"];

// En movimientos (ingresos/egresos) NO se "edita" el registro: `update` habilita
// procesar el flujo (confirmar / preparar / despachar). Por eso se muestra como
// "Procesar". En productos sí es editar.
const MOVEMENT_TABS = ["movement_in", "movement_out"];

export const tabLabel = (tab) => TAB_LABELS[tab] || tab;
export const controlLabel = (control, tab) => {
  if (control === "update" && MOVEMENT_TABS.includes(tab)) {
    return "Procesar";
  }
  return CONTROL_LABELS[control] || control;
};
